var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{staticClass:"field-space",attrs:{"md":_vm.sz}},[_c('el-row',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('el-row',{staticClass:"rowItemInputStyle"},[_c('el-col',{attrs:{"md":24}},[_c('el-row',[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }